enum ProviderPaths {
  CheckIn = 'check_in',
}

export default ProviderPaths;
